import React from "react";
import PropTypes from "prop-types";
import { Button } from "shards-react";
import moment from 'moment';


import Chart from "../../utils/chart";
const axios = require('axios').default;
var tooltipsLabel = [];

class Influence extends React.Component {
    constructor(props) {
        super(props);
        this.minLength = -this.minLength; //-(14 * 24 * 4)--> //14 days
        this.fullChartData = null;
        this.chartData = null;
        this.chartStart = this.minLength;
        this.chartEnd = -1;
        this.maxCnt = 1000;
        this.tweetData = null;
        this.canvasRef = React.createRef();


        // console.log(Math.max(this.tweetData.length));
            // console.log( Math.pow(10, 1+parseInt(Math.log10(Math.max(this.tweetData)))));

    }

    componentDidMount() {
        this.intializeChart();
    }

    intializeChart = () => {
        axios.get(`data/topic${this.props.topicId}_influencers.json`) // data/topicsData1.json
            .then(response => {
                this.chartData = { ...response.data.chartData };
                this.fullChartData = { ...response.data.chartData };
                this.tweetData = response.data.chartData.datasets[0].data;
                this.maxCnt = Math.pow(10, 1+parseInt(Math.log10(Math.max(...this.tweetData))));
                tooltipsLabel = {...this.chartData.tooltipsLabel};
                this.buildChart(this.maxCnt);
                
                
            })

            
    }

    buildChart = (Y_max) => {
        const chartOptions = {
            ...{
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                
                elements: {
                    line: {
                        // A higher value makes the line look skewed at this ratio.
                        tension: 10
                    },
                    point: {
                        radius: 100
                    }
                },
                
                scales: {
                    xAxes: [
                        {
                            // barPercentage: 0.5,
                            barThickness: 'flex',
                            maxBarThickness: 8,
                            minBarThickness: 4,
                            // minBarLength: 2,
                            display: true, 
                            scaleLabel: {
                                display: true,
                                labelString: 'Sorted by time',
                                fontColor: '#f4f4f4',
                            },
                            gridLines: {
                                offsetGridLines: true,
                                fontColor: '#f4f4f4',
                            },
                            time: {
                                displayFormats: {
                                    day: 'MMM D'
                                },
                                unit: 'day',
                                unitStepSize: 1
                            },
                            ticks: {
                                display: true,
                                fontColor: '#f4f4f4',
                            }
                            
                            
                            

                        }
                    ],
                    yAxes: [
                        
                        {
                            // barPercentage: 0.5,
                            // barThickness: 6,
                            // maxBarThickness: 8,
                            minBarLength: 1,
                            // type: 'linear',
                            type: 'linear',
                            autoSkip: false,
                            ticks: {
                                precision: 0,
                                min: 0, //minimum tick
                                fontColor: '#f4f4f4',
                                
                           },
                           

                            scaleLabel: {
                                display: true,
                                labelString: 'Influence Score',
                                fontColor: '#f4f4f4',
                            }
                            
                            
                            

                        }
                    ]



                },
                hover: {
                    mode: "nearest",
                    intersect: false
                },
                tooltips: {
                    
                    // mode: 'index',
                    // intersect: true,
                    callbacks: {
                        // title: function(tooltipItem, data) {
                        //     console.log(tooltipItem);
                        //     return tooltipsLabel[tooltipItem[0].index];
                        //   },
                        title: function(tooltipItem, data) {
                            return tooltipsLabel[tooltipItem[0].index] + "\n" + "Time: "+tooltipItem[0].label;
                          }
                    },
                    custom: false,
                    mode: "nearest",
                    intersect: false
                }
            },
            ...this.props.chartOptions
        };

        // console.log(this.chartData);

        this.chart = new Chart(this.canvasRef.current, {
            type: "bar",
            barThickness: 6,
            data: this.chartData,
            options: chartOptions
        });

        // They can still be triggered on hover.
        const buoMeta = this.chart.getDatasetMeta(0);
        buoMeta.data[0]._model.radius = 0;
        buoMeta.data[
            this.chartData.datasets[0].data.length - 1
            
        ]._model.radius = 0;

        // Render the chart.
        this.chart.render();

    }




    render() {
        return (
            <div style={{height: "250px"}}>
                <canvas
                    // height="70"
                    height="70"
                  
                    ref={this.canvasRef}
                    style={{ maxWidth: "100% !important" }}
                />
            </div>
        );
    }
}

Influence.propTypes = {
    /**
     * The component's title.
     */
    title: PropTypes.string,
    /**
     * The chart dataset.
     */
    chartData: PropTypes.object,
    /**
     * The Chart.js options.
     */
    chartOptions: PropTypes.object
};

Influence.defaultProps = {
    title: "Popular Fake News on Twitter",
};

export default Influence;
